import { render, staticRenderFns } from "./ProgramCenter.vue?vue&type=template&id=319f9a78&scoped=true&lang=pug&"
import script from "./ProgramCenter.vue?vue&type=script&lang=js&"
export * from "./ProgramCenter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "319f9a78",
  null
  
)

export default component.exports